module.exports = __webpack_public_path__ + "4680d6323b39f2d7bd88116f757d8838.svg";